module.exports = ".social-media-icon{\n    font-size: xx-large;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/share-dialog/share-dialog.component.css
// module id = ./src/app/share-dialog/share-dialog.component.css
// module chunks = main